module.exports = __webpack_public_path__ + "static/img/1.496b179.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/sp/1.png
// module id = it0T
// module chunks = 0